module.exports = __webpack_public_path__ + "static/media/logo_edrington.bfcea163.png";